module.exports = __webpack_public_path__ + "static/media/poor.225a0469.svg";